import ForgotPage from './ForgotPage';
import ForgotPageContainer from './ForgotPage.container';

export default ForgotPageContainer(ForgotPage);
